import { Injectable } from "@angular/core";
import { catchError, Observable, throwError } from "rxjs";
import { CountryBackendEmailNotification } from "./interfaces/emailnotification";
import { HttpClient } from "@angular/common/http";
import { environment } from "src/environments/environment";
import { Utils } from "src/app/utils/utils";

@Injectable({providedIn: "root"})
export class EmailNotificationService  {

    private readonly API_EMAILNOTIFICATION = 'api/countrybackend/emailNotification';

    constructor(private readonly http: HttpClient) {}

    getAllEmailNotifications(): Observable<CountryBackendEmailNotification[]> {
        return this.http.get<CountryBackendEmailNotification[]>(environment.endpoint + this.API_EMAILNOTIFICATION);
    }

    createEmailNotification(viewModel: CountryBackendEmailNotification): Observable<CountryBackendEmailNotification> {
        return this.http.post<CountryBackendEmailNotification>(environment.endpoint + this.API_EMAILNOTIFICATION, viewModel).pipe(
            catchError(error => {
                Utils.writeLog(this.http, environment.endpoint + this.API_EMAILNOTIFICATION, error);
                return throwError(() => error);
            })
        );
    }

    updateEmailNotification(vm: CountryBackendEmailNotification, id: number): Observable<boolean> {
        return this.http.put<boolean>(environment.endpoint + this.API_EMAILNOTIFICATION + '/' + id, vm).pipe(
            catchError(error => {
                Utils.writeLog(this.http, environment.endpoint + this.API_EMAILNOTIFICATION + '/' + id + 'vm', error);
                return throwError(() => error);
            })
        );
    }

    deleteEmailNotification(id: number): Observable<boolean> {
        return this.http.delete<boolean>(environment.endpoint + this.API_EMAILNOTIFICATION + '/' + id).pipe(
            catchError(error => {
                Utils.writeLog(this.http, environment.endpoint + this.API_EMAILNOTIFICATION + '/' + id, error);
                return throwError(() => error);
            })
        );;
    }

}